import { useParams } from "react-router-dom";
import { indexStore } from "../../store/indexStore";
import {
  Home,
  ShoppingCart,
  UtensilsCrossed,
  FolderTree,
  Package,
  Settings,
  ArrowUpDown,
  ArrowLeft,
  ArrowRight,
} from "lucide-react";
import { userTypes } from "src/enums/usersTpes";

export const BranchSliderLinks = () => {
  const { branchId } = useParams();
  const { lang } = indexStore();
  return [
    // {
    //   icon: <Home className="h-4 w-4" />,
    //   title: "dashbord.home",
    //   link: `/branches/${branchId}/`,
    // },
    {
      icon: <ShoppingCart className="h-4 w-4" />,
      title: "dashbord.orders",
      link: `/branches/${branchId}/orders`,
      hidden:
        localStorage.getItem("role") !== userTypes.ADMIN &&
        localStorage.getItem("role") !== userTypes.CALLCENTER,
    },
    {
      icon: <UtensilsCrossed className="h-4 w-4" />,
      title: "dashbord.menus",
      link: `/branches/${branchId}/menus`,
    },
    {
      icon: <FolderTree className="h-4 w-4" />,
      title: "dashbord.categories",
      link: `/branches/${branchId}/categories`,
    },
    {
      icon: <Package className="h-4 w-4" />,
      title: "dashbord.items",
      link: `/branches/${branchId}/items`,
    },
    {
      icon: <Settings className="h-4 w-4" />,
      title: "dashbord.options",
      link: `/branches/${branchId}/options`,
      hidden:
        localStorage.getItem("role") !== userTypes.ADMIN &&
        localStorage.getItem("role") !== userTypes.DATAMANAGER,
    },
    {
      icon: <ArrowUpDown className="h-4 w-4" />,
      title: "dashbord.sort",
      link: `/branches/${branchId}/sort`,
      hidden:
        localStorage.getItem("role") !== userTypes.ADMIN &&
        localStorage.getItem("role") !== userTypes.DATAMANAGER,
    },
    {
      icon:
        lang == "en" ? (
          <ArrowLeft className="h-4 w-4" />
        ) : (
          <ArrowRight className="h-4 w-4" />
        ),
      title: "",
      link: `/branches/`,
    },
  ];
};
